import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'integrations-index',
        path: '/integrations',
        component: () => import('@/pages/integrations/IntegrationsIndex.vue'),
        redirect: { name: 'integrationstable-index' },
        meta: {
            title: 'Integrations',
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('can access integrations'),
        },
        children: [
            {
                path: '',
                name: 'integrationstable-index',
                component: () => import('@/pages/integrations/IntegrationsTable.vue'),
                meta: {
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('can access integrations'),
                },
            },
            {
                path: ':integrationId(\\d+)',
                name: 'integration-index',
                component: () => import('@/pages/integrations/IntegrationsView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('can access integrations'),
                },
            },
        ],
    },
];
